import React, { useState, useEffect, createContext, useContext } from 'react'
import { useAccordion } from './AccordionContext'
import { AccordionItemType } from './accordionReducer'

export const useGetItem = (value = '') => {
  const { state } = useAccordion()
  const [item, setItem] = useState<AccordionItemType>({
    isOpen: false,
    value: '',
  })

  useEffect(() => {
    if (value) {
      const foundItem = (state?.items || []).find((currentItem) => currentItem.value === value)

      if (foundItem) {
        setItem({
          ...foundItem,
          state: foundItem.isOpen ? 'open' : 'closed',
        })
      }
    }
  }, [value, state?.items])

  return item
}

const AccordionItemContext = createContext({})

type AccordionContextItemProps = {
  value: string
  children: React.ReactNode
}

export const AccordionItemProvider = ({ value, children }: AccordionContextItemProps) => {
  const item = useGetItem(value)

  return (
    <AccordionItemContext.Provider
      value={{
        value,
        ...item,
      }}
    >
      {children}
    </AccordionItemContext.Provider>
  )
}

export const useAccordionItem = (): AccordionItemType => useContext(AccordionItemContext)

export default {
  ...AccordionItemContext,
  Provider: AccordionItemProvider,
}
